export interface ICarouselSliderState {
    currentSlideIndex: number;
    slideCount: number;
    showFullScreenLink: boolean;
    // citiLogoTemplate: string; // for V1 Landscape
    slideBaseHeight: number;
    slideBaseWidth: number;
    slideBaseZoom: number;
    presentationHTMLFragments: Array<string>;
    presentationJSONFragments: Array<JSON>;
    slideHeight: number;
    slideZoom: {
        transform: string,
        transformOrigin: string
    };
    modalStatus: boolean;
    bodySource: any;
}

export const CAROUSEL_SLIDER_STATE: ICarouselSliderState = {
    currentSlideIndex: 0,
    slideCount: 1,
    showFullScreenLink: true,
    // citiLogoTemplate: ''; // for V1 Landscape
    slideBaseHeight: 828,
    slideBaseWidth: 1075,
    slideBaseZoom: 1,
    presentationHTMLFragments: [],
    presentationJSONFragments: [],
    slideHeight: 828,
    slideZoom: {
        transform: 'scale(1, 1)',
        transformOrigin: '0 0'
    },
    modalStatus: false,
    bodySource: null,
};
